import Backtop from './Backtop.vue'

/* istanbul ignore next */
Backtop.install = function (app) {
  app.component(Backtop.name, Backtop)
}

export default Backtop
